import axios from 'axios'

import apiClient from '../../api/apiClient'
import { ENDPOINTS } from '../../api/endpoints'
import { UnauthorizedError } from '../../auth/UnauthorizedError'
import { NotFoundError, NotFoundResponse } from '../../errors/NotFoundError'
import { Report, ReportParams } from '../../types'

export async function fetchReportParams(workspaceId: string, reportId: string): Promise<ReportParams> {
  try {
    const response = await apiClient.get<ReportParams>(`reports/${workspaceId}/${reportId}`)
    return response.data
  } catch (error: unknown) {
    handleError(error)
    throw error
  }
}

export async function fetchAdminReportParams(workspaceId: string, reportId: string): Promise<ReportParams> {
  try {
    const response = await apiClient.get<ReportParams>(`reports/${workspaceId}/${reportId}`)
    return response.data
  } catch (error: unknown) {
    handleError(error)
    throw error
  }
}

export async function fetchReports(siteId: string): Promise<Report[]> {
  try {
    const response = await apiClient.get<Report[]>(`reports?siteId=${siteId}`)
    return response.data
  } catch (error: unknown) {
    handleError(error)
    throw error
  }
}

export async function fetchAdminReports(): Promise<Report[]> {
  try {
    const response = await apiClient.get<Report[]>(ENDPOINTS.reports.adminList)
    return response.data
  } catch (error: unknown) {
    handleError(error)
    throw error
  }
}

function handleError(error: unknown) {
  if (!axios.isAxiosError(error)) return
  if (error.response?.status === 401) {
    throw new UnauthorizedError()
  }
  if (error.response?.status === 404) {
    const data = error.response.data as Partial<NotFoundResponse> | undefined
    throw new NotFoundError({ detail: data?.detail ?? 'Not found' })
  }
}
